export default __webpack_public_path__ + "static/media/helloemoji.79e7fe8c.svg";